import { render } from "./CustomerReportView.vue?vue&type=template&id=1745222a&scoped=true"
import script from "./CustomerReportView.vue?vue&type=script&lang=js"
export * from "./CustomerReportView.vue?vue&type=script&lang=js"

import "./CustomerReportView.vue?vue&type=style&index=0&id=1745222a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1745222a"]])

export default __exports__